import { useEffect } from 'react';
import {
  DEFAULT_DAILY_TIME,
  TIME_PICKER_FORMAT,
  DB_TIME_FORMAT
} from 'common/constants/constants';
import _ from 'lodash';

import { formatDateToUTC } from 'common/utils/utils';
import { createCustomizationModalOptions } from 'modals/modal-options-factory';
import {
  DefinitionLevels,
  SettingValues
} from 'common/services/settings.service';
import { useDispatch } from 'react-redux';
import { toggleModal } from 'state/callers';
import useSettingsService from 'components/hooks/useSettingsService';

const useCurrentTeamUpdater = ({
  currentTeam,
  workingDays,
  selectedContributorIds,
  setSelectedContributorIds
}) => {
  const dispatch = useDispatch();
  const { updateSetting, getSettingOrDefinitionValue } = useSettingsService();

  useEffect(() => {
    const currentTeamId = _.get(currentTeam, 'id');

    if (currentTeamId) {
      const teamWorkingDays = getSettingOrDefinitionValue({
        name: SettingValues.WORKING_DAYS,
        definitionLevel: DefinitionLevels.TEAM,
        teamId: currentTeamId
      });

      const teamDailyTime = getSettingOrDefinitionValue({
        name: SettingValues.DAILY_TIME,
        definitionLevel: DefinitionLevels.TEAM,
        teamId: currentTeamId
      });

      const dailyTime = teamDailyTime
        ? teamDailyTime
        : formatDateToUTC(
            DEFAULT_DAILY_TIME,
            TIME_PICKER_FORMAT,
            DB_TIME_FORMAT
          );
      if (!teamWorkingDays && !teamDailyTime) {
        const options = createCustomizationModalOptions({
          updateSetting,
          currentTeam,
          workingDays,
          dailyTime
        });

        dispatch(toggleModal(options));
      }
    }

    if (currentTeam && selectedContributorIds.length) {
      const { contributor_ids = [] } = currentTeam;
      if (!contributor_ids.includes(selectedContributorIds[0])) {
        setSelectedContributorIds([]);
      }
    }
  }, [currentTeam]); // eslint-disable-line
};

export default useCurrentTeamUpdater;
